<template>
	<div class="tools-box">
		<div class="excle-btn fl-l">
			<i class="excle-icon"></i>
			<a class="excle-a" href="javascript:void(0);" @click="exportExcle">导出excel</a>
			<el-button type="primary" size="small" class="search-btn" @click="goCustomSaleNew" v-if="reportName === 'customGoodDetail'">返回汇总</el-button>
			<el-button type="primary" size="small" class="search-btn" @click="goRoute" v-if="reportName === 'goodMarket' || reportName === 'customSale' || reportName === 'transaction'">体验新版(推荐)</el-button>
			<el-button type="primary" size="small" class="search-btn" @click="goRoute" v-if="reportName === 'goodMarketNew' || reportName === 'customSaleNew' || reportName === 'transactionNew'">返回旧版</el-button>
			<el-radio-group v-if="reportName === 'orderItem' || reportName === 'refundOrderItem'" v-model="type" size="mini" style="margin-left:10px" @change="typeChange">
				<el-radio-button label="明细"></el-radio-button>
				<el-radio-button label="按客户"></el-radio-button>
				<el-radio-button label="按商品"></el-radio-button>
			</el-radio-group>
		</div>
	</div>
</template>
<script>
export default {
	name: 'ToolsBox',
	props: {
		reportName: String,
		getFiltersParams: {
			type: Function,
			default: () => {}
		}
	},
	data () {
		return {
			type: '明细'
		}
	},
	created () {
		let key = window.location.href.split('/').pop().split('?queryParams=')[0]
		if (key === 'orderItem' || key === 'refundOrderItem') {
			this.type = '明细'
		}
		if (key === 'orderItem1' || key === 'refundOrderItem1') {
			this.type = '按客户'
		}
		if (key === 'orderItem2' || key === 'refundOrderItem2') {
			this.type = '按商品'
		}
	},
	methods: {
		typeChange () {
			let query = this.initFilters(this.getFiltersParams())
			let queryParams = encodeURI(JSON.stringify(query))
			let route = ''
			let name = this.reportName
			if (this.type === '明细') {
				route = `/reportform/${name}`
			}
			if (this.type === '按客户') {
				route = `/reportform/${name}1`
			}
			if (this.type === '按商品') {
				route = `/reportform/${name}2`
			}
			this.$router.push(route + '?queryParams=' + queryParams)
		},
		initFilters (data) {
			let arr = [...data.filtersParams, ...data.cParams]
			let query = {}
			arr.forEach(item => {
				query[item.field] = item
			})
			return query
		},
		exportExcle () {
			this.$emit('exportExcle')
		},
		goCustomSaleNew () {
			// const filtersParamsObj = this.$route.query.filtersParamsObj
			this.$router.push({
				path: '/reportform/customSaleNew'
			})
		},
		goRoute () {
			let name = ''
			switch (this.reportName) {
			case 'goodMarket':
				name = 'goodMarketNew'
				break
			case 'goodMarketNew':
				name = 'goodMarket'
				break
			case 'customSale':
				name = 'customSaleNew'
				break
			case 'customSaleNew':
				name = 'customSale'
				break
			case 'transaction':
				name = 'transactionNew'
				break
			case 'transactionNew':
				name = 'transaction'
				break
			}
			this.$router.push('/reportform/' + name)
		}
	}
}
</script>
<style lang="stylus" scoped>
.tools-box {
	font-size: 16px;
	.excle-btn {
		margin-left: 12px;
		height: 50px;
		display: flex;
		align-items: center;
		.excle-icon {
			background-image:url('~images/icon/reportform/excle-icon.png')
			background-repeat:no-repeat
			background-position: center
			width:40px
			height:50px
			display:inline-block
		}
		.excle-a {
			vertical-align: top;
			display:inline-block
			height:50px
			line-height:50px
		}
		.search-btn {
			margin-left: 20px
		}
	}
}
</style>

